// Recovered compiled webpack factory 91225. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { q: () => n });
  let n = (t, e, i) => {
    let n = e - t;
    return 0 === n ? 1 : (i - t) / n;
  };
}
